import React, { FunctionComponent } from "react";
import { ReactComponent as IconHelp } from "@Icons/help-circle.svg";
import "./style.scss";

interface Props {
  info: string;
}

const CartTooltip: FunctionComponent<Props> = ({ info }) => {
  return (
    <div className="CartTooltip">
      <IconHelp />
      <span className="CartTooltip-text">{info}</span>
    </div>
  );
};

export default CartTooltip;
